import React, { Component, Fragment } from 'react';
import { NavMenu } from '../../Controls/NavMenu';

import './Resources/css/site.css';

import Top from './Blocks/Top';
import About from './Blocks/About';
import Footer  from './Blocks/Footer';
import AppWrapper from '../../Controls/Scafolding/AppWrapper';
import Common from '../../Shared/Common';

export class RTech extends Component {

    constructor(props) {
        super(props);
        Common.log('Component Init -> /RTechStart');

        let logoImagePath = require("./Resources/Images/logoTransparent.png");
        let logoIconPath = require("./Resources/Images/logo.ico");

        this.state = {
            brandCode: 'RTech',

            menu: {

                hasLogo: false,
                logoUrl: '', // logoImagePath,
                logoWidth: '250px',

                styles: {},
                insertBars: false,

                text: 'RTech - Rico Technologies',
                //icon: //,logoIconPath,

                items: [
                    { linkLabel: 'about', linkUrl: '#about' },
                    { linkLabel: 'hobbies', linkUrl: '#hobbies' },
                    { linkLabel: 'expertise', linkUrl: '#expertise' },
                    { linkLabel: 'contact', linkUrl: '#contact', isClosing: true  }
                ],
            }
        };
    }

    render() {
        return (
            <AppWrapper wrapClass="rtech">
                <Top />
                <NavMenu menu={this.state.menu} offset="50" addClass="Menu sticky-top" />

                <About />
                <Footer />

            </AppWrapper>
        );
    }
}



